export default {
  'global#home': 'Home',
  'global#maps': 'Mappe',
  'global#works': 'Opere',
  'global#date_human': 'Do MMMM YYYY',
  'global#layout_error_title': 'Spiacenti, si è verificato un errore',
  'global#layout_error_description':
    "Prova a ricaricare la pagina tra qualche istante e se il problema persiste contatta l'amministratore della piattaforma.",
  'readmore#label': 'Mostra tutto',
  'search#works_total': '<strong>{ total }</strong> Manoscritti',
  'search#works_total_1': '<strong>{ total }</strong> Manoscritto',
  'search#works_total_0': 'Nessun Manoscritto',
  'search#person_total': '<strong>{ total }</strong> persone',
  'search#person_total_1': '<strong>{ total }</strong> persona',
  'search#person_total_0': 'Nessuna persona',
  'search#object_total': '<strong>{ total }</strong> oggetti',
  'search#object_total_1': '<strong>{ total }</strong> oggetto',
  'search#object_total_0': 'Nessun oggetto',
  'search#books_total': '<strong>{ total }</strong> Libri',
  'search#books_total_1': '<strong>{ total }</strong> Libro',
  'search#books_total_0': 'Nessun Libro',
  'search#witnesses_total': '<strong>{ total }</strong> Testimoni',
  'search#witnesses_total_1': '<strong>{ total }</strong> Testimone',
  'search#witnesses_total_0': 'Nessun Testimone',
  'search#placeholder_query': 'Cerca nei titoli',
  'search#placeholder_query-content': 'Cerca nei manoscritti contenuti',
  'search#header_authors': 'Autori',
  'search#header_keywords': 'Keywords',
  'search#header_works': 'Opere',
  'search#header_libraries': 'Biblioteca',
  'search#header_cities': 'Città',
  'search#header_dates': 'Date',
  'search#facets_title': 'Filtra i risultati',
  'search#filters_title': 'Filtri attivi:',
  'search#sort_title': 'Ordine',
  'search#sort_score': 'Ordine per pertinenza',
  'search#sort_asc': 'Ordine alfabetico (A→Z)',
  'search#sort_desc': 'Ordine alfabetico (Z→A)',
  'search#fallback_text':
    'La tua ricerca non ha dato risultati. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#fallback_button': 'Resetta la ricerca',
  'search#ko_text':
    'Oops, abbiamo riscontrato un errore nella ricerca. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#ko_button': 'Resetta la ricerca',
  'search#description_button': 'Info',
  'search#description_link': 'Ok, ho capito',
  'resource#authors': 'di',
  'resource#date': 'pubblicato il',
  'resource#time_to_read': 'lettura di',
  'resource#metadata': 'Metadati',
  'resource#metadata_size': 'Dimensioni',
  'resource#metadata_annotazioni': 'Annotazioni',
  'resource#collection-carte': 'Carte',
  'search#header_genres': 'Genere',
  'search#header_language': 'Lingua',
  'search#header_library': 'Biblioteca',
  'search#date': 'data',
  'search#bibliographies_total':
    '<strong>{ total }</strong> riferimenti bibliografici',
  'search#bibliographies_total_1':
    '<strong>{ total }</strong> riferimento bibliografico',
  'search#bibliographies_total_0': 'Nessun riferimento bibliografico',
  'search#placeholder_authors': 'Cerca un autore',
  'search#title_bibliographies': 'Bibliografia',
  'search#biographies_total': '<strong>{ total }</strong> vite antiche',
  'search#biographies_total_1': '<strong>{ total }</strong> vita antica',
  'search#biographies_total_0': 'Nessuna vita antica',
  'search#title_biographies': 'Vite antiche',
  'search#iconographies_total': '<strong>{ total }</strong> iconografie',
  'search#iconographies_total_1': '<strong>{ total }</strong> icongrafia',
  'search#iconographies_total_0': 'Nessuna iconografia',
  'search#title_iconographies': 'Vite antiche',
  'search#tools_total': '<strong>{ total }</strong> materiali e strumenti',
  'search#tools_total_1': '<strong>{ total }</strong> materiale e strumento',
  'search#tools_total_0': 'Nessun materiale e strumento',
  'search#title_tools': 'Materiali e strumenti',
  'search#resultsamount': 'Risultati per pagina',
  'tabs#manuscript_metadata': 'Metadati',
  'tabs#manuscript_series': 'Serie',

  // RICERCA AVANZATA
  'advancedsearch#submit': 'Cerca',
  'advancedsearch#reset': 'Pulisci i campi',
  'advancedsearch#results_total': '<strong>{ total }</strong> risultati',
  'advancedsearch#results_total_1': '<strong>{ total }</strong> risultato',
  'advancedsearch#results_total_0': 'Nessun risultato',
  'advancedsearch#results_number': 'Risultati per pagina',
  'advancedsearch#fulltext_text': 'Cerca nel portale (in tutti i campi)',
  'advancedsearch#label_title': 'Titolo',
  'advancedsearch#label_text': 'Cerca nei testi',
  'advancedsearch#text_info':
    'Effettuando un\'interrogazione per lemma, puoi ricorrere a caratteri speciali per affinarla: * corrisponde a un numero qualsiasi di caratteri ed è possibile usarlo in qualsiasi posizione in una stringa di caratteri; ? corrisponde a un singolo carattere alfabetico in una posizione specifica di una stringa.<br>Inoltre, mettere tra “virgolette” più termini permetterà di trovare tutti i risultati con corrispondenza esatta; OR permette di cercare questo O quello: la ricerca restituirà i risultati relativi ai due termini o ad entrambi; AND permette di cercare questo E quello: l\'operatore restituirà solo i risultati relativi a entrambi i termini.<br>Una volta avviata la ricerca, selezionando i singoli risultati ottenuti verrai indirizzato nella sezione dell\'opera in cui l\'occorrenza è presente; per raggiungere l’esatta porzione di testo interessata puoi poi scorrere il testo o, in alternativa, effettuare una ricerca veloce attraverso il comando CTRL+F',
  'advancedsearch#distance_value': 'Parole interposte',
  'advancedsearch#section_annotation': 'Cerca nelle annotazioni',
  'advancedsearch#label_trascription': 'Cerca nelle trascrizioni',
  'advancedsearch#label_comment': 'Cerca nei commenti',
};
